import styled from "styled-components";

export const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
  margin-top: 40px;
`;
